"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHotelQuantity = function SvgHotelQuantity(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "hotel-quantity_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#hotel-quantity_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "hotel-quantity_svg__stroke",
    id: "hotel-quantity_svg__a",
    d: "M1 3.89V4a.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5v6.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V11a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5v-.11a.61.61 0 0 0-.354-.554L7.919.693a1 1 0 0 0-.838 0L1.354 3.336A.61.61 0 0 0 1 3.89Z",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("g", {
    className: "hotel-quantity_svg__fill",
    fill: "#17181A",
    mask: "url(#hotel-quantity_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "hotel-quantity_svg__rectY",
    x: "0%",
    y: "100%",
    rx: 0,
    ry: 0,
    width: "100%",
    height: "100%"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHotelQuantity);
var _default = exports["default"] = Memo;